import { Divider, Paper, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat } from '../../../../../../helpers';
import { useNotification } from '../../../../../../helpers/Notification';
import BotonComponent from '../../../../../dashboard/components/BotonNuevo';
import { updateEstatusPlanEvaluacionAction } from '../../PlanEvaluacionAction';

const InfoPlanEvaluacion = ({ activo, planEvaluacionStore }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  function metricas() {
    const tTemas = activo.temas.length;

    const { tEvaluaciones, tActividades, tPuntos } = activo.temas.reduce(
      (acc, tema) => {
        acc.tEvaluaciones += tema.evaluaciones.length;
        tema.evaluaciones.forEach((eva) => {
          acc.tActividades += eva.instrumentos.length;
          acc.tPuntos += eva.instrumentos.reduce(
            (sum, act) => sum + Number(act.ponderacion),
            0,
          );
        });
        return acc;
      },
      { tEvaluaciones: 0, tActividades: 0, tPuntos: 0 },
    );

    return (
      <>
        <Stack direction="column">
          <Stack direction="row">
            <Typography sx={{ width: '40%' }} variant="body1" color="initial">
              <strong>Temas: </strong>
              {tTemas}
            </Typography>
            <Typography variant="body1" color="initial">
              <strong>Evaluaciones: </strong>
              {tEvaluaciones}
            </Typography>
          </Stack>
          <Stack direction="row">
            <Typography sx={{ width: '40%' }} variant="body1" color="initial">
              <strong>Actividades: </strong>
              {tActividades}
            </Typography>
            <Typography variant="body1" color="initial">
              <strong>Actividades extras: </strong>
              {activo.actividadesExtras.length}
            </Typography>
          </Stack>
        </Stack>
        <Divider sx={{ my: 1 }} />
        <Typography variant="body1" color="initial">
          <strong>Puntos total: </strong>
          {tPuntos} Puntos
        </Typography>
      </>
    );
  }

  const updateEstatusHandler = async () => {
    await updateEstatusPlanEvaluacionAction(
      { dispatch, notify },
      activo.id,
      {
        idEntidad: entidadesStore.activo.id,
        idEstatus: activo.estatus.id === 1 ? 2 : 1,
      },
      planEvaluacionStore.params,
      planEvaluacionStore.activo,
    );
  };

  return (
    <Paper elevation={4} sx={{ p: 2 }}>
      <Typography sx={{ fontSize: '16pt', fontWeight: 'bold' }}>
        {activo.fechaBloque.bloquePedagogico.nombre}
      </Typography>
      <Typography>
        {activo.fechaBloque.periodoAcademico.nombre} (
        {activo.fechaBloque.periodoAcademico.desde}-
        {activo.fechaBloque.periodoAcademico.hasta})
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Typography>
        <strong>Desde:</strong>{' '}
        {dateformat(activo.fechaBloque.desde, { inverse: true })}
      </Typography>
      <Typography>
        <strong>Hasta:</strong>{' '}
        {dateformat(activo.fechaBloque.hasta, { inverse: true })}
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Typography>
        <strong>Materia:</strong> {activo.materia.nombre}
      </Typography>
      <Stack direction="row" spacing={2}>
        <Typography>
          <strong>Sección:</strong> {activo.seccion.nombre}
        </Typography>
        <Typography>
          <strong>Turno:</strong> {activo.seccion.turno}
        </Typography>
      </Stack>
      <Typography>
        <strong>Nivel académico:</strong>{' '}
        {activo.seccion.nivelAcademico.nivelAcademico.nombre}
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Typography sx={{ mb: 1 }}>
        <strong>Tema indispensable:</strong>
        {activo.temaIndispensable ?? '--'}
      </Typography>
      <Typography sx={{ mb: 1 }}>
        <strong>Tema generador:</strong>
        {activo.temaGenerador ?? '--'}
      </Typography>
      <Typography sx={{ mb: 1 }}>
        <strong>Descripción:</strong>
        {activo.desc ?? '--'}
      </Typography>
      <Divider sx={{ my: 1 }} />
      {metricas()}
      <Divider sx={{ my: 1 }} />
      {(loginStore.isAdmin ||
        loginStore.isRoot ||
        loginStore.isAdminTeacher) && (
        <BotonComponent
          click={updateEstatusHandler}
          green={activo.estatus.id === 1}
          red={activo.estatus.id === 2}
          text={activo.estatus.id === 1 ? 'ACTIVO' : 'BLOQUEADO'}
          mr={2}
        />
      )}
    </Paper>
  );
};

export default InfoPlanEvaluacion;
